import { PreferenceStore } from "../preference-store";
import UIKeys from "./ui.keys";

interface IStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export default class LocalStorage {
  private readonly storage: IStorage;
  private readonly prefix: string = "sct_";

  public constructor(getStorage = (): IStorage => window.localStorage) {
    this.storage = getStorage();
  }

  public get(key: string): string | null {
    return this.storage.getItem(`${this.prefix}${key}`);
  }

  public set(key: string, value: string): void {
    return this.storage.setItem(`${this.prefix}${key}`, value);
  }

  public getBool(key: string, defaultValue?: boolean): boolean {
    const value = this.get(key);
    if (value) {
      return value === "true";
    }
    return defaultValue;
  }

  public getInt(key: string, defaultValue?: number): number {
    const value = this.get(key);
    if (value) {
      return +value;
    }
    return defaultValue;
  }

  startListening(): void {
    PreferenceStore.INSTANCE.on("change:showTransitionPriorities", (_, v) => this.set(UIKeys.transitionPriorities, v));
    PreferenceStore.INSTANCE.on("change:enableSnaplines", (_, v) => this.set(UIKeys.snaplines, v));
    PreferenceStore.INSTANCE.on("change:gridEnabled", (_, v) => this.set(UIKeys.gridEnabled, v));
    PreferenceStore.INSTANCE.on("change:gridShow", (_, v) => this.set(UIKeys.gridShow, v));
    PreferenceStore.INSTANCE.on("change:gridSize", (_, v) => this.set(UIKeys.gridSize, v));
    PreferenceStore.INSTANCE.on("change:isDark", (_, v) => this.set(UIKeys.darkTheme, v));
  }

  loadIntoPreferenceStore(): void {
    PreferenceStore.INSTANCE.showTransitionPriorities = this.getBool(
      UIKeys.transitionPriorities,
      PreferenceStore.INSTANCE.defaults().showTransitionPriorities
    );
    PreferenceStore.INSTANCE.enableSnaplines = this.getBool(
      UIKeys.snaplines,
      PreferenceStore.INSTANCE.defaults().enableSnaplines
    );
    PreferenceStore.INSTANCE.gridEnabled = this.getBool(
      UIKeys.gridEnabled,
      PreferenceStore.INSTANCE.defaults().gridEnabled
    );
    PreferenceStore.INSTANCE.gridShow = this.getBool(UIKeys.gridShow, PreferenceStore.INSTANCE.defaults().gridShow);
    PreferenceStore.INSTANCE.gridSize = this.getInt(UIKeys.gridSize, PreferenceStore.INSTANCE.defaults().gridSize);
    PreferenceStore.INSTANCE.isDark = this.getBool(UIKeys.darkTheme, PreferenceStore.INSTANCE.defaults().isDark);
  }
}
